export class TerminalResponse {
  errors?: Array<string>;
}
